<template>
    <form @submit.prevent="submitPrevent" id="form" name="equipment_form" ref="business_information_form" class="content-inner formValidation">
        <div class="row" id="equipments">
            <div class="col-12">
                <div class="row" v-if="!is_reviewing">
                    <div class="col-md-12 col-12" >
                        <div class="panel-sub-heading headingLarge">
                            <span class="h5 markedBottom bold">{{ lang('equipment_and_online_selection') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-show="packageList.length > 0">
                <np-radios
                        :label="lang('select_package')"
                        :help-text="getTooltipText('select_package_tooltip')"
                        :id="'select_package'"
                        :name="'select_package'"
                        :mode="`separate`"
                        ref="package"
                        :big-label="true"
                        :placeholder="lang('package')"
                        :options="packageList"
                        :required="true"
                        :auto-select="false"
                        @input="alertChangePackage"
                        v-model="package_external_id"
                ></np-radios>
                <np-notice v-if="selectedPackageIsExpired && !isConvertedQuote" :notice="lang('your_selected_package_has_expired')" :notice-class="'alert-warning'" :dismissable="true"></np-notice>
                <np-input :id="'section'" :no-wrapper="true" :name="'section'" :type="'hidden'" model-value="EQUIPMENTS"></np-input>
                <div class="row marginBottom10" v-if="!!package_external_id && showSection('equipment_offerings')">
                    <div class="col-lg-6 col-md-6 col-12">
                        <np-select2
                                :label="lang('equipment_offering')"
                                :id="'equipment_offering'"
                                :name="'equipment_offering'"
                                ref="equipment_offering"
                                :placeholder="lang('equipment_offering')"
                                :parameters="equipment_offerings"
                                v-show="equipment_offerings.length > 1"
                                :required="true"
                                v-model="equipment_offer.equipment_offering_external_id"
                        ></np-select2>
                    </div>
                    <div v-if="equipment_is_loading" class="col-12">
                        <np-skeleton :type="'equipment'"></np-skeleton>
                    </div>
                    <div v-else class="col-12">
                        <div class="" v-if="hasTerminalEquipmentList || hasBundlePackage" >
                            <div class="">
                                <div class="row">
                                    <div class="col-12" ref="agreement_length"
                                         v-if="!!equipment_offer.equipment_offering_external_id">
                                        <div id="agreement-lengths-block" class="row">
                                            <div class="col-12">
                                                <div class="panel-sub-heading headingSmall">
                                                    <span class="markedBottom">{{lang('agreement_type')}}</span>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-sm-12 col-12"
                                                 v-if="equipment_offer.acquiring_only === '1'">
                                                <np-radios
                                                    :id="'acquiring_only'"
                                                    :aria-label="lang('acquiring_only')"
                                                    :hide-label="true"
                                                    :name="'acquiring_only'"
                                                    :mode="'co-join'"
                                                    :required="true"
                                                    :disabled="true"
                                                    :options="acquiringOnlyParam"
                                                    :model-value="'1'">
                                                </np-radios>
                                            </div>
                                            <div class="col-lg-6 col-sm-12 col-12"
                                                 v-if="leaseAgreementParam.length > 0">
                                                <np-radios
                                                        :id="'agreement_length'"
                                                        :label="lang('rental_agreement')"
                                                        :name="'agreement_length'"
                                                        :mode="'co-join'"
                                                        :required="true"
                                                        @input="filterByAgreementLength"
                                                        :disabled="leaseAgreementParam.length === 1"
                                                        :options="leaseAgreementParam"
                                                        v-model="quote.agreement_length">
                                                </np-radios>
                                            </div>
                                            <div class="col-lg-6 col-sm-12 col-12"
                                                 v-if="purchaseAgreementParam.length > 0">
                                                <np-radios
                                                        ref=""
                                                        :id="'purchase_agreement_length'"
                                                        :label="lang('purchase')"
                                                        :name="'purchase_agreement_length'"
                                                        :mode="'co-join'"
                                                        :required="true"
                                                        :options="purchaseAgreementParam"
                                                        :disabled="purchaseAgreementParam.length === 1"
                                                        @input="filterByAgreementLength"
                                                        v-model="quote.purchase_agreement_length">
                                                </np-radios>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div>
                                            <div id="accordionNine" v-if="hasTalechServices">
                                                <div id="talech_service" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(talech_service_block)"
                                                         :id="`heading_talech_service`" data-bs-toggle="collapse" :data-bs-target="`#collapse_talech_service`"
                                                         aria-expanded="true" :aria-controls="`collapse_talech_service`">
                                                        <h5 class="mb-0">
                                                            <span v-if="talech_service_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('talech_services')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedTalechService > 0"> {{numberSelectedTalechService}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div  v-if="talech_service_block.is_open" data-parent="#accordionNine" id="collapse_talech_service" :aria-labelledby="`heading_talech_service`" class="collapse card-body show">
                                                        <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                        <div class="col-12" v-if="isTalechService(bundle_item)">
                                                            <talech-service
                                                                :bundle_item="bundle_item"
                                                                :bundle_item_key="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                @terminal-toggled="toggleTerminus($event, 'terminal')"
                                                                :key="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`"
                                                                :is-view="true"
                                                            />
                                                        </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionSeven" v-if="hasSpecialOffers">
                                                <div id="special_offer" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(special_offer_block)"
                                                         :id="`heading_special_offer`" data-bs-toggle="collapse" :data-bs-target="`#collapse_special_offer`"
                                                         aria-expanded="true" :aria-controls="`collapse_special_offer`">
                                                        <h5 class="mb-0">
                                                            <span v-if="special_offer_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('special_offers')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedSpecialOffers > 0"> {{numberSelectedSpecialOffers}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionSeven" id="collapse_special_offer" :aria-labelledby="`heading_special_offer`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isSpecialOfferService(bundle_item) && bundle_item.display">
                                                                    <equipment-services :bundle_item="bundle_item"
                                                                                        :is-standalone="false"
                                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-services>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionEight" v-if="hasThirdPartyEquipments">
                                                <div id="third_party_equipment" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(third_party_equipment_block)"
                                                         :id="`heading_third_party_equipment`" data-bs-toggle="collapse" :data-bs-target="`#collapse_third_party_equipment`"
                                                         aria-expanded="true" :aria-controls="`collapse_third_party_equipment`">
                                                        <h5 class="mb-0">
                                                            <span v-if="third_party_equipment_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('third_party_equipments')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedThirdPartyEquipments > 0"> {{numberSelectedThirdPartyEquipments}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionEight" id="collapse_third_party_equipment" :aria-labelledby="`heading_third_party_equipment`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 col-12" v-if="isThirdPartyEquipmentService(bundle_item) && bundle_item.display">
                                                                    <third-party-equipment
                                                                            :bundle_item="bundle_item"
                                                                            :is-standalone="false"
                                                                            @third-party-equipment-toggled="toggleThirdPartyEquipment($event, 'terminal', equipment_offer)"
                                                                            :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                            :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </third-party-equipment>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionOne" v-if="hasEquipments || hasBundlePackage">
                                                <div id="terminals" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(terminals_block)"
                                                         :id="`heading_terminal`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal`"
                                                         aria-expanded="true" :aria-controls="`collapse_terminal`">
                                                        <h5 class="mb-0">
                                                            <span v-if="terminals_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('equipments')}}</span>
<!--                                                                        <span class="badge badge-info" v-if="numberSelectedTerminals > 0"> {{parseInt(numberSelectedTerminals) + parseInt(numberSelectedBundlePackages)}} {{lang('selected')}}</span>-->
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionOne" id="collapse_terminal" :aria-labelledby="`heading_terminal`" class="collapse card-body show">
                                                        <div class="row">
                                                                <div class="col-12" id="your-selection-header" v-if="numberSelectedTerminals > 0 || numberSelectedBundlePackages > 0" >
                                                                    <div class="panel-sub-heading headingSmall">
                                                                        <span class="markedBottom">{{lang('your_selection')}}</span>
                                                                    </div>
                                                                </div>
                                                                <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isEquipment(bundle_item) && bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                                    <equipment-terminals
                                                                        :bundle="equipment_offer.equipment_list"
                                                                        :bundle_item="bundle_item"
                                                                        @terminal-toggled="toggleTerminus($event, 'terminal')"
                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-terminals>
                                                                </div>
                                                                </template>
                                                                <div class="col-12">
                                                                    <div
                                                                        v-for="(bundle_package, bundle_package_idx) in equipment_offer.bundle_packages">
                                                                        <template v-if="bundle_package.display && bundleItemIsSelected(bundle_package)">
                                                                            <equipment-bundles
                                                                                :bundle_package="bundle_package"
                                                                                @bundle-toggled="toggleTerminus($event, 'bundle')"
                                                                                :bundle_key="bundle_package_idx">
                                                                            </equipment-bundles>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                                <div class="col-6"
                                                                     v-if=" (numberSelectedTerminals > 0 || numberSelectedBundlePackages > 0)
                                                                            && hasMultipleEquipmentBundleItems && hasUnselectedItems">
                                                                    <np-checkbox ref="other_available_terminals"
                                                                                 :id="'other_available_terminals'"
                                                                                 :name="'other_available_terminals'"
                                                                                 :description="lang('other_available_terminals')"
                                                                                 :value="'1'"
                                                                                 :mode="'button'"
                                                                                 v-model="show_available_terminals">
                                                                    </np-checkbox>
                                                                </div>

                                                                <template v-if="(show_available_terminals == '1' && hasMultipleEquipmentBundleItems)
                                                                || (numberSelectedTerminals == 0 && numberSelectedBundlePackages == 0 ) ">
                                                                    <div class="col-12" v-if="show_available_terminals == '1' && hasMultipleEquipmentBundleItems">
                                                                        <div class="panel-sub-heading headingSmall">
                                                                            <span class="markedBottom">{{lang('other_available_terminals')}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                    <div class="col-12"
                                                                         v-if="isEquipment(bundle_item) && bundle_item.display && !bundleItemIsSelected(bundle_item)">
                                                                        <equipment-terminals
                                                                            :bundle="equipment_offer.equipment_list"
                                                                            :bundle_item="bundle_item"
                                                                            @terminal-toggled="toggleTerminus($event, 'terminal')"
                                                                            :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                            :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                        </equipment-terminals>
                                                                    </div>
                                                                    </template>
                                                                    <div class="col-12">
                                                                        <div
                                                                            v-for="(bundle_package, bundle_package_idx) in equipment_offer.bundle_packages">
                                                                            <template v-if="bundle_package.display && !bundleItemIsSelected(bundle_package)">
                                                                                <equipment-bundles
                                                                                    :bundle_package="bundle_package"
                                                                                    @bundle-toggled="toggleTerminus($event, 'bundle')"
                                                                                    :bundle_key="bundle_package_idx">
                                                                                </equipment-bundles>
                                                                            </template>
                                                                        </div>
                                                                    </div>
                                                                </template>

<!--                                                            <template>-->
<!--                                                                <div class="col-12">-->
<!--                                                                    <div-->
<!--                                                                        v-for="(bundle_package, bundle_package_idx) in equipment_offer.bundle_packages">-->
<!--                                                                        <template v-if="bundle_package.display">-->
<!--                                                                        <equipment-bundles-->
<!--                                                                            :bundle_package="bundle_package"-->
<!--                                                                            @bundle-toggled="toggleTerminus($event, 'bundle')"-->
<!--                                                                            :bundle_key="bundle_package_idx">-->
<!--                                                                        </equipment-bundles>-->
<!--                                                                        </template>-->
<!--                                                                    </div>-->
<!--                                                                </div>-->
<!--                                                            </template>-->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="accordionTwo" v-if="hasAccessories">
                                                <div id="accessories" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(accessories_block)"
                                                         :id="`heading_accessories`" data-bs-toggle="collapse" :data-bs-target="`#collapse_accessories`"
                                                         aria-expanded="true" :aria-controls="`collapse_accessories`">
                                                        <h5 class="mb-0">
                                                            <span v-if="accessories_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('equipment_accessories')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedAccessories > 0"> {{numberSelectedAccessories}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionTwo" id="collapse_accessories" :aria-labelledby="`heading_accessories`" class="collapse card-body">
                                                        <div class="row">

                                                                <div class="col-12" v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items"
                                                                         v-if="isAccessory(bundle_item) && bundle_item.display">
                                                                        <equipment-terminals
                                                                                :bundle="equipment_offer.equipment_list"
                                                                                :bundle_item="bundle_item"
                                                                                :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                        </equipment-terminals>
                                                                </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionThree" v-if="hasServices">
                                                <div id="terminal_services" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(terminal_services_block)"
                                                         :id="`heading_terminal_services`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal_services`"
                                                         aria-expanded="true" :aria-controls="`collapse_terminal_services`">
                                                        <h5 class="mb-0">
                                                            <span v-if="terminal_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('equipment_services')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedServices > 0"> {{numberSelectedServices}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionThree" id="collapse_terminal_services" :aria-labelledby="`heading_terminal_services`" class="collapse card-body">
                                                        <div class="row">
                                                                <div class="col-12" v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items"
                                                                     v-if="isService(bundle_item) && bundle_item.display">
                                                                        <equipment-services :bundle_item="bundle_item"
                                                                                            :is-standalone="false"
                                                                                            :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                            :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                        </equipment-services>
                                                                </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionFive" v-if="hasGeneralServices">
                                                <div id="general_services" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(general_services_block)"
                                                         :id="`heading_general_services`" data-bs-toggle="collapse" :data-bs-target="`#collapse_general_services`"
                                                         aria-expanded="true" :aria-controls="`collapse_general_services`">
                                                        <h5 class="mb-0">
                                                            <span v-if="general_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('services')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedGeneralServices > 0"> {{numberSelectedGeneralServices}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionFive" id="collapse_general_services" :aria-labelledby="`heading_general_services`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="((isGeneralService(bundle_item) && canGeneralServiceDisplay(equipment_offer.equipment_list, bundle_item)) || isElavonGateway(bundle_item)) && bundle_item.display">
                                                                    <equipment-services
                                                                        :bundle="equipment_offer.equipment_list"
                                                                        :bundle_item="bundle_item"
                                                                        :is-standalone="false"
                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-services>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionFour" v-show="hasStandaloneServices">
                                                <div id="standalone_services" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(standalone_services_block)"
                                                         :id="`heading_standalone_services`" data-bs-toggle="collapse" :data-bs-target="`#collapse_standalone_services`"
                                                         aria-expanded="true" :aria-controls="`collapse_standalone_services`">
                                                        <h5 class="mb-0">
                                                            <span v-if="standalone_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('additional_options')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedStandaloneServices > 0"> {{numberSelectedStandaloneServices}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionFour" id="collapse_standalone_services" :aria-labelledby="`heading_standalone_services`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-show="isStandaloneService(bundle_item) && bundle_item.display">
                                                                    <equipment-service-pci :bundle_item="bundle_item"
                                                                                           :is-standalone="true"
                                                                                           v-if="!!bundle_item.service && bundle_item.service.service_api_code === 'pciInfo'"
                                                                                           :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                           :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-pci>
                                                                    <equipment-service-statement :bundle_item="bundle_item"
                                                                                                 :is-standalone="true"
                                                                                                 v-else-if="!!bundle_item.service && statementTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                                 :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                                 :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-statement>
                                                                    <equipment-service-distribution :bundle_item="bundle_item"
                                                                                                    :is-standalone="true"
                                                                                                    v-else-if="!!bundle_item.service && distributionTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                                    :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                                    :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-distribution>
                                                                    <equipment-service-dcc :bundle_item="bundle_item"
                                                                                           :is-standalone="true"
                                                                                           v-else-if="!!bundle_item.service && (bundle_item.service.service_api_code === 'dynamicCurrencyConversion')"
                                                                                           :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                           :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-dcc>
                                                                    <equipment-services :bundle_item="bundle_item"
                                                                                        v-else
                                                                                        :is-standalone="true"
                                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-services>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="package_external_id != '' " class="row ">
                            <div class="col-12">
                                <np-notice :notice-class="'alert-info'" :notice="lang('select_equipment_offering')"
                                           :dismissable="false">
                                </np-notice>
                            </div>
                        </div>
                        <div v-else-if="package_external_id == '' " class="row ">
                            <div class="col-12">
                                <np-notice :notice-class="'alert-info'" :notice="lang('please_select_package')"
                                           :dismissable="false">
                                </np-notice>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="row" v-if="!!package_external_id && showSection('online_offerings')">
                    <div class="col-lg-6 col-md-6 col-12">
                        <np-select2
                                :label="lang('online_offering')"
                                :id="'online_offering'"
                                :name="'online_offering'"
                                :show-label="true"
                                ref="online_offering"
                                v-show="online_offerings.length > 1"
                                :placeholder="lang('online_offering')"
                                :parameters="online_offerings"
                                :searchable="true"
                                :required="true"
                                @input="getOnlineOffer"
                                v-model="online_offer.equipment_offering_external_id"
                        ></np-select2>
                    </div>
                    <div v-if="online_is_loading" class="col-12">
                        <np-skeleton :type="'panel_only'"></np-skeleton>
                    </div>
                    <div v-else class="col-12">
                        <div class="row" v-if="hasOnlineEquipmentList">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{ lang('online_ecommerce_products') }}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div id="accordionSevenOnline" v-if="hasOnlineSpecialOffers">
                                    <div id="special_offer_online" class="card">
                                        <div class="card-header cursorPointer" @click="toggleAccordionSection(special_offer_block)"
                                             :id="`heading_special_offer_online`" data-bs-toggle="collapse" :data-bs-target="`#collapse_special_offer_online`"
                                             aria-expanded="true" :aria-controls="`collapse_special_offer_online`">
                                            <h5 class="mb-0">
                                                <span v-if="special_offer_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                <span>{{lang('special_offers')}}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineSpecialOfferServices > 0">
                                                    {{numberSelectedOnlineSpecialOfferServices}} {{lang('selected')}}
                                                </span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionSevenOnline" id="collapse_special_offer_online"
                                             :aria-labelledby="`heading_special_offer_online`" class="collapse card-body show">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12" v-if="isSpecialOfferService(bundle_item) && bundle_item.display">
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            :is-standalone="false"
                                                                            :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                            :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="accordionEightOnline" v-if="hasThirdPartyOnline">
                                    <div id="third_party_online" class="card">
                                        <div class="card-header cursorPointer" @click="toggleAccordionSection(third_party_online_block)"
                                             :id="`heading_third_party_online`" data-bs-toggle="collapse" :data-bs-target="`#collapse_third_party_online`"
                                             aria-expanded="true" :aria-controls="`collapse_third_party_online`">
                                            <h5 class="mb-0">
                                                <span v-if="third_party_online_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                <span>{{lang('third_party_equipments')}}</span>
                                                <span class="badge badge-info" v-if="numberSelectedThirdPartyOnline > 0"> {{numberSelectedThirdPartyOnline}} {{lang('selected')}}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionEightOnline" id="collapse_third_party_online" :aria-labelledby="`heading_third_party_online`" class="collapse card-body show">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12"
                                                         v-if="isThirdPartyEquipmentService(bundle_item) && bundle_item.display">
                                                        <third-party-equipment
                                                            :bundle_item="bundle_item"
                                                            :is-standalone="false"
                                                            @third-party-equipment-toggled="toggleThirdPartyEquipment($event, 'online', online_offer)"
                                                            :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                            :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </third-party-equipment>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="accordionOneOnline" v-if="hasOnlineServices">
                                    <div id="online_services" class="card">
                                        <div class="card-header cursorPointer"
                                             @click="toggleAccordionSection(online_services_block)"
                                             :id="`heading_online_services`" data-bs-toggle="collapse"
                                             :data-bs-target="`#collapse_online_services`"
                                             aria-expanded="true" :aria-controls="`collapse_online_services`">
                                            <h5 class="mb-0">
                                            <span v-if="online_services_block.is_open" class="caretSign rotate"><i
                                                class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i
                                                    class="fa fa-caret-down"></i></span>
                                                <span>{{ lang('equipment_services') }}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineTerminalServices > 0"> {{
                                                        numberSelectedOnlineTerminalServices
                                                    }} {{ lang('selected') }}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionOneOnline" id="collapse_online_services"
                                             :aria-labelledby="`heading_online_services`"
                                             class="collapse show card-body">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12" v-if="!!bundle_item.display && isService(bundle_item)">
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            :is-standalone="false"
                                                                            :is-online="true"
                                                                            :id="`quote_online_offer_bundle_service${item_idx}_selected`"
                                                                            :name="`quote[online_offer][bundle][service][${item_idx}][selected]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="accordionTwoOnlineGeneralServices" v-if="hasOnlineGeneralServices">
                                    <div id="online_general_services" class="card">
                                        <div class="card-header cursorPointer"
                                             @click="toggleAccordionSection(online_general_services_block)"
                                             :id="`heading_online_general_services`" data-bs-toggle="collapse"
                                             :data-bs-target="`#collapse_online_general_services`"
                                             aria-expanded="true"
                                             :aria-controls="`collapse_online_general_services`">
                                            <h5 class="mb-0">
                                              <span v-if="online_general_services_block.is_open"
                                                    class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i
                                                    class="fa fa-caret-down"></i></span>
                                                <span>{{ lang('general_services') }}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineGeneralServices > 0"> {{
                                                        numberSelectedOnlineGeneralServices
                                                    }} {{ lang('selected') }}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionTwoOnlineGeneralServices"
                                             id="collapse_online_general_services"
                                             :aria-labelledby="`heading_online_general_services`"
                                             class="collapse card-body">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12" v-if="isGeneralService(bundle_item) && bundle_item.display">
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            :is-standalone="false"
                                                                            :id="`quote_online_offer_bundle_service${item_idx}_selected`"
                                                                            :name="`quote[online_offer][bundle][service][${item_idx}][selected]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="accordionThreeOnlineStandaloneServices" v-if="hasOnlineStandaloneServices">
                                    <div id="online_standalone_services" class="card">
                                        <div class="card-header cursorPointer"
                                             @click="toggleAccordionSection(online_standalone_services_block)"
                                             :id="`heading_online_standalone_services`" data-bs-toggle="collapse"
                                             :data-bs-target="`#collapse_online_standalone_services`"
                                             aria-expanded="true"
                                             :aria-controls="`collapse_online_standalone_services`">
                                            <h5 class="mb-0">
                                                <span v-if="online_standalone_services_block.is_open"
                                                      class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i
                                                    class="fa fa-caret-down"></i></span>
                                                <span>{{ lang('additional_options') }}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineStandaloneServices > 0"> {{numberSelectedOnlineStandaloneServices}} {{ lang('selected') }}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionThreeOnlineStandaloneServices"
                                             id="collapse_online_standalone_services"
                                             :aria-labelledby="`heading_online_standalone_services`"
                                             class="collapse show card-body">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12"
                                                         v-if="isStandaloneService(bundle_item) && bundle_item.display">
                                                        <equipment-service-pci :bundle_item="bundle_item"
                                                                               :is-standalone="true"
                                                                               v-if="!!bundle_item.service && (bundle_item.service.service_api_code === 'pciInfo' || bundle_item.service.service_api_code === 'pciinfo')"
                                                                               :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                               :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-pci>
                                                        <equipment-service-statement :bundle_item="bundle_item"
                                                                                     :is-standalone="true"
                                                                                     v-else-if="!!bundle_item.service && statementTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                     :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                                     :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-statement>
                                                        <equipment-service-distribution :bundle_item="bundle_item"
                                                                                        :is-standalone="true"
                                                                                        v-else-if="!!bundle_item.service && distributionTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                        :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                                        :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-distribution>
                                                        <equipment-service-dcc :bundle_item="bundle_item"
                                                                               :is-standalone="true"
                                                                               v-else-if="!!bundle_item.service && (bundle_item.service.service_api_code === 'dynamicCurrencyConversion')"
                                                                               :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                               :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-dcc>
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            v-else
                                                                            :is-standalone="true"
                                                                            :is-online="true"
                                                                            @online-service-toggled="toggleOnlineTerminus($event, 'service')"
                                                                            :id="`quote_online_offer_bundle_service${item_idx}_selected`"
                                                                            :name="`quote[online_offer][bundle][service][${item_idx}][selected]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-show="packageList.length === 0">
                <np-skeleton :type="'equipment'"></np-skeleton>
            </div>
        </div>
        <template v-if="!package_external_id || loading_finished">
            <div class="row mt-4" style="border-top: 1px solid #b2c6d0"  v-if="is_reviewing" >
                <div class="col-12">
                    <div class="my-3">
                        <a class="btn btn-default" @click="updateQuote"> {{lang('save')}}</a>
                    </div>
                </div>
            </div>
            <div class="row mt-4" style="border-top: 1px solid #b2c6d0" v-if="!is_reviewing">
                <div class="col-12">
                    <div class="my-3">
                        <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                        <button type="button" class="btn btn-default me-1" @click="doContinue" :disabled="disableContinueBtn"> {{lang('continue')}} {{ !!disableContinueBtn ? '...' : ''}}</button>
                    </div>
                </div>
            </div>
        </template>
    </form>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import equipmentMixin from "../../../utils/equipment-mixin";
    import Vue from 'vue';
    import {allianceCode} from "../../../entities/default";

    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton,
    } from "netpify/components";
    import NpMultiselect from "netpify/components/np-multiselect.vue";
    import EquipmentServices from '../../../components/equipment-services.vue';
    import EquipmentServicePci from '../../../components/equipment-service-pci.vue';
    import EquipmentServiceStatement from '../../../components/equipment-service-statement.vue';
    import EquipmentServiceDistribution from '../../../components/equipment-service-distribution.vue';
    import EquipmentServiceDCC from '../../../components/equipment-service-dcc.vue';
    import EquipmentTerminals from '../../../components/equipment-terminals.vue';
    import ThirdPartyTerminals from '../../../components/equipment-service-thirdpartyterminal.vue';
    import TalechService from '../../../components/talech-service.vue';
    import EquipmentBundles from '../../../components/equipment-bundles.vue';
    import * as types from "../../../stores/constants";
    import {EquipmentOffering} from "./entities";
    import EventBus from "../../../utils/event_bus";
    import useModuleStore from "../../../stores";

    export default {
        name: "Equipments",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            EquipmentServiceDistribution,
           'np-multiselect': NpMultiselect,
            'np-entry': NPEntry,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'equipment-services': EquipmentServices,
            'equipment-service-pci': EquipmentServicePci,
            'equipment-service-statement': EquipmentServiceStatement,
            'equipment-service-distribution': EquipmentServiceDistribution,
            'equipment-service-dcc': EquipmentServiceDCC,
            'third-party-equipment': ThirdPartyTerminals,
            'talech-service': TalechService,
            'equipment-terminals': EquipmentTerminals,
            'equipment-bundles': EquipmentBundles,
        },
        data() {
            return {
                page_label: 'select_your_equipment',
                tinybox_index: null,
                dragging: false,
                equipment_is_loading: true,
                online_is_loading: true,
                bundle_item:[],
                statementTypes: {
                    'billingStatement': 'billingStatementType',
                    'fundingStatement': 'fundingStatementType',
                    'electronicStatement': 'electronicStatementType',
                },
                distributionTypes: {
                    'distributions.chargeback': 'distributions.chargeback',
                    'distributions.retrieval': 'distributions.retrieval',
                },
                equipment_offer_cache: {},
                package_external_id: '',
                old_package_external_id: '',
                old_equipment_offering_id: '',
                abortRouteLeave: false,
                show_available_terminals: false,
            }
        },
        metaInfo() {
            return {
                title: this.lang('equipment_selection')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.setAppPageTitle(vm.page_label);
                //prevent user manual url change
                //prevent user manual url change
                // if (!!vm.merchant_user_access && vm.merchant_user_access.hasOwnProperty('application')
                //     && vm.merchant_user_access.application.length > 0) {
                //   let quote = vm.merchant_user_access.application.find(app => {
                //     return app.quote_external_id === vm.$route.params.quote_id
                //   })
                //
                //   // if (!!quote)
                //   //   vm.$router.push({path: `/quote/view/${vm.$route.params.quote_id}/business/products/`})
                // }
            });
        },
        beforeRouteLeave(to, from, next) {
            let vm = this;
            // if(this.abortRouteLeave){
            //     next();
            //     return; //prevent it from doing anything else
            // }

            if(!this.checkDestinationRoute(to, from)){ //if user is going backwards, don't validate
                if (this.pageHasData() && !this.disable_go_back_warning_modal) {
                    this.alertBackRouteWarning((doCall = true) => {
                        useModuleStore().commit(types.TOGGLE_LOADING, true);
                        vm.retrieveQuote(doCall).then(function (doCall) {
                            useModuleStore().commit(types.TOGGLE_LOADING, false);
                            return next(doCall)})
                        })
                } else {
                    next()
                    return;
                }
            }else {
                if (this.isLockedQuote) {
                    next(true);
                } else {
                    if (!this.inQuoteViewMode) {
                        // if business information page,
                        //console.log('quote', this.quote)
                        this.updateQuote(() => {
                            next()
                        })
                    } else {
                        next(true)
                    }
                }
            }
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        mounted() {
            this.is_view = false;
            this.disableContinueBtn = false;

            //this field was added so that when a user changes the package on review page without saving, the change does not affect the quote object.
            //so if they don't save, the quote.package_external_id remains the same and if the go back to step 1 and save, it will save the old package_external_id,
            //not the new unsaved package from the review page.
            //if there are any issues with this variable, it might be best to add it to vuex state so it connects directly to the quote.package_external_id
            //view page doesn't need this variable.
            this.package_external_id = !!this.quote.package_external_id ? this.quote.package_external_id : '';
            this.old_package_external_id = ''; //when remounted, make sure the old_package is empty, it shouldn't h
            //moved from mixin to avoid multiple calls by  child components loading mixin
            //revived because outlet bank can update equipment offers
            if (!!this.quote.equipment_offer && !!this.quote.equipment_offer.equipment_offering_external_id) {
                this.getEquipmentOffer(this.quote.equipment_offer.equipment_offering_external_id)
            }
            if (!!this.quote.online_offer && !!this.quote.online_offer.equipment_offering_external_id) {
                this.getOnlineOffer(this.quote.online_offer.equipment_offering_external_id)
            }

               // this.addValidationRules()
        },
        created() {
        },
        computed: {
            hasUnselectedItems: function() {
                let vm = this,
                    bundle_items = vm.equipment_offer.equipment_list.bundle_items,
                    bundle_packages = vm.equipment_offer.bundle_packages,
                    unselected_items_exist = false;
        
                //console.log('hasUnselectedItems :=> ', vm.equipment_offer, bundle_items);
        
                unselected_items_exist =  bundle_items.some((bundle_item) => {
                    //console.log('Point :=> ', bundle_item, vm.bundleItemIsSelected(bundle_item));
                    return vm.isEquipment(bundle_item) && bundle_item.display && !vm.bundleItemIsSelected(bundle_item)
                });
                
                unselected_items_exist = !unselected_items_exist
                    ? bundle_packages.some((bundle_package) => {
                        //console.log('Point :=> ', bundle_package, vm.bundleItemIsSelected(bundle_package));
                        return bundle_package.display && !vm.bundleItemIsSelected(bundle_package)
                      })
                    : unselected_items_exist;
        
                return unselected_items_exist
            },
            hasMultipleEquipmentBundleItems: function () {
                //if package has more than one terminal or bundle package that can be displayed ie. display = true
                let number_terminal = 0, number_bundles = 0;

                if (this.hasEquipments) {
                    number_terminal = this.equipment_offer.equipment_list.bundle_items.filter(obj => !!obj.display && !!this.isEquipment(obj)).length
                }

                if (this.hasBundlePackage) {
                    number_bundles = this.equipment_offer.bundle_packages.filter(obj => !!obj.display).length
                }
                return (number_terminal + number_bundles) > 1
            },
            packageTooltipText: function () {
                let new_tooltip_alliance_codes = ['UKTISBSANTANDER', 'SBUKSAN', 'UKTIELAVONDIRECT']; // Santander,Elavon direct UK
                let new_ireland_tooltip_alliance_codes = ['IETIELAVONDIRECT']; // Elavon Direct Ireland
                let no_tooltip = ['GBTIOPAYO', 'IETIOPAYO', 'GBTIBREATHE'] // Opayo and Breathepay

                let original_hardcode_tooltip = this.lang('select_package_tooltip');

                if (new_tooltip_alliance_codes.includes(allianceCode)) {
                    original_hardcode_tooltip = this.lang('new_select_package_tooltip')
                }
                else if (new_ireland_tooltip_alliance_codes.includes(allianceCode)) {
                    original_hardcode_tooltip = this.lang('new_select_package_tooltip_irl');
                }
                else if (no_tooltip.includes(allianceCode)) {
                    original_hardcode_tooltip = '';
                }

                return this.getTooltipText('select_package_tooltip', original_hardcode_tooltip);
            },
            loading_finished: function () {
                return (this.showSection('equipment_offerings') && !this.equipment_is_loading)
                    || (this.showSection('online_offerings') && !this.online_is_loading);
            }
        },
        methods: {
            showSection: function (section = 'equipment_offerings') {
                //if equipment we shouldn't section show for ECOM_ONLY payment method, if online, we shouldn't show section for F2F_ONLY
                let not_applicable_payment_method = section === 'equipment_offerings' ? this.payment_method.PAYMENT_METHOD_ECOM_ONLY :
                    this.payment_method.PAYMENT_METHOD_F2F_ONLY;

                let quote_is_acquiring_only = this.quote.acquiring_only == '1';
                if (quote_is_acquiring_only) {
                    let package_external_id = !!this.package_external_id ? this.package_external_id : null;

                    let package_list = package_external_id !== null ? this.matched_packages[this.package_external_id] : null

                    if (package_list !== null && this.packageHasOffering(package_list, section)) {
                        let acquiring_offer = package_list[section].filter(offer => {
                            return offer.acquiring_only == '1'
                        })

                        return acquiring_offer.length > 0;
                    }
                } else {
                    return this.quote.payment_method !== not_applicable_payment_method
                }
            },
            goBack: function (){
                this.abortRouteLeave = true;
              this.$router.push({path:  this.quote_root_path +'business/'})
            },
            doContinue: function (){
                let vm = this;
                    let path_to = this.quote_root_path + 'business/pricing/';
                if (this.inQuoteViewMode){
                    // this.nextPage();
                    this.$router.push({path: path_to})
                }else {
                    vm.$router.push({path: path_to})
                }
            },
            pageHasData: function (){
                $('[id^=heading_]').removeClass('collapsed')
                $('[id^=collapse_]').addClass('show');
                return this.formHasValues($('#form'))
            },
            updateQuote(callback = null){
                let vm = this;
                if (!!this.disableContinueBtn) { //avoid double click
                    return;
                }
                if (vm.validateEquipments()) {
                    this.disableContinueBtn = true;
                    //don't set the selected package_external_id in the quote. this prevents a situation where the update equipment fails
                    //but the quote object still carries the new package_external_id. If the user goes back to the business_info page and saves,
                    //the bad package_external_id will overwrite the good one.
                    //Instead, we add the package_external_id to the quote object in actions.js after a successful update equipment
                    //this fixes ELV-4074

                    let payload_data = this.jsonCopy(this.quote);
                    if (!!payload_data.equipment_offer) {
                        payload_data.equipment_offer = this.formatEquipmentOfferForWAF(payload_data.equipment_offer);
                    }
                    if (!!payload_data.acquiring_offer) {
                        payload_data.acquiring_offer = this.formatAcquiringOfferForWAF(payload_data.acquiring_offer);
                    }
                    const payload = {...payload_data, ...{package_external_id: this.package_external_id}}
                    //update quote
                    vm[types.UPDATE_QUOTE](payload).then(response => {
                        if (response.data.result === 'SUCCESS') {
                            vm.notifySuccess(vm.lang('equipment_updated_successfully'));
                            if (vm.is_reviewing) {
                              vm.$emit('close_review_section');
                            }

                            //update faster payment for deposit bank on UI
                            let {outlet} = response.data;

                            if (!!outlet) {
                                let {banks} = outlet;
                                if (!!banks && vm.objectIsNotEmpty(banks) && vm.outlets.length > 0 && vm.npPropertyExistAndIsArray(vm.outlets[0], 'banks')) {

                                    let deposit_bank = Object.values(banks).find(bank => bank.account_type === 'DEBIT')
                                    if (!!deposit_bank) {
                                        vm.outlets[0].banks.forEach(bank => {
                                            if (bank.account_type === 'DEBIT') {
                                                bank.faster_payments = deposit_bank.faster_payments;
                                            }
                                        })
                                    }
                                }
                            }

                            if (!!callback) { //call back is the next function in nav guard
                                callback();
                            }
                        }else{
                            this.disableContinueBtn = false;
                        }
                    }).catch(error => {
                        //console.log(error)
                    })

                }

                this.revertContinueButton();
            },
            validateEquipments: function (){
                //open all accordions before validating. Accordions don't validate nicely when closed.
                $('[id^=heading_]').removeClass('collapsed')
                $('[id^=collapse_]').addClass('show');
                let form_is_valid = this.validateForm('#form');
                let form = this.getFormData($('#form')), section = form.section;

                this.quote.section = section;
                let quote_is_acquiring_only = this.quote.acquiring_only == '1';

                //TODO clean up.
                //if no offering is selected throw error
                //if offering is selected but no bundle item, throw error.
                let is_valid_equipment = false, is_valid_online = false;

                //validate offer package expiration
                if (!this.isConvertedQuote) {
                    if (!this.validateOfferPackagePeriod()) {
                        return false;
                    }
                }

                //validate Equipment offerings
                if (this.objectIsNotEmpty(this.equipment_offer)) {
                    is_valid_equipment = this.checkEquipmentOfferIsSelected(this.equipment_offer)
                }

                //validate online offerings
                if (this.objectIsNotEmpty(this.online_offer)) {
                    is_valid_online = this.checkOnlineOfferIsSelected(this.online_offer);
                }

                if (!quote_is_acquiring_only) {
//if card acceptance is both check both are selected.
//                     if  is online and is_valid_online is false, throw error
//                     else if its equipment  and is_valid_equipment  is false throw error
//                     else if is both and either is_valid_online or is_valid_equipment is false
                    if ((this.quote.payment_method === this.payment_method.PAYMENT_METHOD_ECOM_ONLY || this.quote.payment_method === this.payment_method.PAYMENT_METHOD_BOTH)
                        && !is_valid_online) {
                        this.notifyError(this.lang('validation_error'), this.lang('please_select_atleast_equipment_in_online_offering'));
                        return false;
                    }

                    if ((this.quote.payment_method === this.payment_method.PAYMENT_METHOD_F2F_ONLY
                        || this.quote.payment_method === this.payment_method.PAYMENT_METHOD_BOTH)
                        && !is_valid_equipment && !this.isAcquiringOnlyEquipmentOffer(this.equipment_offer)) {
                        this.notifyError(this.lang('validation_error'), this.lang('please_select_only_one_equipment_in_equipment_offering'));

                        // this.notifyError(this.lang('validation_error'), this.lang('please_select_atleast_equipment_in_equipment_offering'));
                        return false;
                    }
                }else if (quote_is_acquiring_only && !is_valid_equipment && !is_valid_online){
                    this.notifyError(this.lang('validation_error'), this.lang('please_select_only_one_equipment_in_equipment_offering'));

                    return false;
                }

                //if no errors set the data
                if (is_valid_equipment || this.isAcquiringOnlyEquipmentOffer(this.equipment_offer)) {
                    this.quote['equipment_offer'] = this.getSelectedEquipmentOffer(this.equipment_offer);
                }else if (this.quote.payment_method === this.payment_method.PAYMENT_METHOD_ECOM_ONLY){
                    this.quote[ 'equipment_offer'] = {}; //unset equipment if the payment method is online only
                }

                if (is_valid_online) {
                    this.quote['online_offer' ]= this.getSelectedEquipmentOffer(this.online_offer);
                }else if (this.quote.payment_method === this.payment_method.PAYMENT_METHOD_F2F_ONLY){
                    this.quote['online_offer'] = {};
                }


                // if (!is_valid_equipment && !is_valid_online){
                //     this.notifyError('Validation Error', 'Please select an Offering');
                //     return false;
                // }

                return form_is_valid;
            },
            alertChangePackage: function ($event){
                let vm = this;
                if (this.checkEquipmentOfferIsSelected(this.equipment_offer) || this.checkOnlineOfferIsSelected(this.online_offer)) {
                    //show  alert if they click yes, carry on witrh change else set old value.
                    this.$swal({
                        title: this.lang('are_you_sure'),
                        text: this.lang('once_changed_you_will_lose_the_previously_saved_equipments'),
                        icon: "warning",
                        confirmButtonColor: '#e64942',
                        cancelButtonColor: '#efefef',
                        showCancelButton: true,
                        confirmButtonText: this.lang('ok'),
                        cancelButtonText:this.lang('cancel'),
                        customClass: {
                            cancelButton: 'order-1',
                            confirmButton: 'order-2',
                        },
                        dangerMode: true,
                    })
                        .then((willDelete) => {
                            if (willDelete.value) {
                                // vm.old_package_external_id = vm.quote.package_external_id; // Was failing when toggling between the services. Sometimes the old id is the current id so it doesn't toggle back, the watch is more sure
                                // cache the selection and dump the quote offering
                                this.equipment_offer_cache[this.quote.equipment_offer.equipment_offering_external_id] = this.quote.equipment_offer;
                                this.quote.equipment_offer = {};
                                this.quote.online_offer  = {};
                                this.quote.agreement_length  = '';
                                this.quote.purchase_agreement_length  = '';
                                this.removeExpiredPackages();
                                this.setOfferings($event, true);
                            } else {
                                //revert to the previous value.
                                this.package_external_id = this.old_package_external_id
                            }
                        });
                }else{
                    this.equipment_offer_cache[this.quote.equipment_offer.equipment_offering_external_id] = this.quote.equipment_offer;
                    this.quote.equipment_offer = {};
                    this.quote.online_offer  = {};
                    this.quote.agreement_length  = '';
                    this.quote.purchase_agreement_length  = '';
                    // vm.old_package_external_id = vm.quote.package_external_id;
                    this.removeExpiredPackages();
                    this.setOfferings($event);
                }
            },
            removeExpiredPackages: function () {
                let vm = this, expired_index_array = [];
                this.packageList.forEach((obj, index) => {
                    // check the package is expired and it's not the selected package
                    if(!!obj.is_expired && obj.value !== vm.package_external_id){
                        expired_index_array.push(index)
                    }
                })
                if (expired_index_array.length > 0) {
                    expired_index_array.forEach(expired_index => {
                        this.packageList.splice(expired_index, 1)
                    })
                }
            },
            // alertChangeEquipmentOffer: function ($event){
            //     //show  alert if they click yes, carry on witrh change else set old value.
            //     this.$swal({
            //         title: this.lang('are_you_sure'),
            //         text: this.lang('once_changed_you_will_lose_the_previously_saved_equipments'),
            //         icon: "warning",
            //         buttons: true,
            //         dangerMode: true,
            //     })
            //         .then((willDelete) => {
            //             if (willDelete) {
            //                 // dump everything
            //                 this.equipment_offer_cache[this.quote.equipment_offer.equipment_offering_external_id] = this.quote.equipment_offer;
            //                 this.quote.equipment_offer = {};
            //                 this.getEquipmentOffer($event);
            //             } else {
            //                 //revert to the previous value.
            //                 this.equipment_offer.equipment_offering_external_id = this.old_equipment_offering_id
            //             }
            //         });
            // },
            toggleTerminus($event, item_type) {
                let selected = $event['is_boarding_activated'] === '1';
                let item_id = item_type === 'terminal'
                    ? $event['equipment_bundle_item_external_id']
                    : $event['equipment_bundle_external_id'];

                this.equipment_offer.equipment_list.bundle_items.forEach((bundle_item) => {
                    if (this.isEquipment(bundle_item) && item_id != bundle_item['equipment_bundle_item_external_id'] && !!selected ) {
                        bundle_item['selected'] = ''; //bundle_item.terminal_quantity
                        bundle_item['is_boarding_activated'] = '0'; //bundle_item.terminal_quantity
                        bundle_item['terminal_quantity'] = 0;
                    }
                });

                this.equipment_offer.bundle_packages.forEach((bundle_package) => {
                    if (item_id !== bundle_package['equipment_bundle_external_id'] && !!selected) {
                        bundle_package['selected'] = '0';
                        bundle_package['is_boarding_activated'] = '0';
                        bundle_package.bundle_items.forEach(bundle_item => {
                            bundle_item['selected'] = false; //bundle_item.terminal_quantity
                            bundle_item['is_boarding_activated'] = '0'; //bundle_item.terminal_quantity
                            bundle_item['terminal_quantity'] = 0;
                        })
                    }
                })

                //scrollto terminal section
                if (!!selected) {
                    setTimeout(function () {
                        let element = document.getElementById('terminals');
                        element.scrollIntoView({behavior: "smooth", inline: "nearest"});
                    }, 500)
                }
            },
            toggleThirdPartyEquipment($event, item_type, offer) {
                let vm = this, selected = $event['is_boarding_activated'] === '1', item_id = $event['equipment_bundle_item_external_id'];

                offer.equipment_list.bundle_items.forEach((bundle_item) => {
                    if (this.isThirdPartyEquipmentService(bundle_item) && item_id != bundle_item['equipment_bundle_item_external_id'] && !!selected ) {
                        bundle_item['selected'] = ''; //bundle_item.terminal_quantity
                        bundle_item['is_boarding_activated'] = '0'; //bundle_item.terminal_quantity
                        bundle_item['terminal_quantity'] = 0;

                        //deselect features
                        if (vm.npPropertyExistAndIsArray(bundle_item, 'service_features')){
                            bundle_item.service_features.forEach(feature => {
                                feature['selected'] = ''; //bundle_item.terminal_quantity
                            })
                        }
                        //deselect charges
                        if (vm.npPropertyExistAndIsArray(bundle_item, 'service_charges')){
                            bundle_item.service_charges.forEach(charge => {
                                charge['selected'] = ''; //bundle_item.terminal_quantity
                            })
                        }
                    }
                });
            },
            toggleOnlineTerminus($event, item_type) {
                let vm = this, selected = $event['is_boarding_activated'] === '1', item_id = $event['equipment_bundle_item_external_id'];

                this.online_offer.equipment_list.bundle_items.forEach((bundle_item) => {
                    if (this.isService(bundle_item) && item_id != bundle_item['equipment_bundle_item_external_id'] && !!selected ) {
                        bundle_item['selected'] = ''; //bundle_item.terminal_quantity
                        bundle_item['is_boarding_activated'] = '0'; //bundle_item.terminal_quantity
                        bundle_item['terminal_quantity'] = 0;

                        //deselect features
                        if (vm.npPropertyExistAndIsArray(bundle_item, 'service_features')){
                            bundle_item.service_features.forEach(feature => {
                                feature['selected'] = ''; //bundle_item.terminal_quantity
                            })
                        }
                        //deselect charges
                        if (vm.npPropertyExistAndIsArray(bundle_item, 'service_charges')){
                            bundle_item.service_charges.forEach(charge => {
                                charge['selected'] = ''; //bundle_item.terminal_quantity
                            })
                        }
                    }

                });
            },
        },
        watch: {
            "quote.package_external_id": {
                immediate: true,
                handler: function(val, oldVal){
                    //when we initiate quote and redirect to equipment, package_external_id is not set on mounted since quote hasn't been fetched yet.
                    if(!!val){
                        this.package_external_id = val;
                    }
                }
            },
            "package_external_id": {
                immediate: true,
                handler: function(val, oldVal) {

                    // if (!!val) {
                    //     this.setOfferings(val);
                    // }

                    //TODO reuse when ELV 746 is confirmed -
                    //only do this once. Every other change should listen to the input event on the radio
                    if (!!val && (this.quote.payment_method !== this.payment_method.PAYMENT_METHOD_ECOM_ONLY && !this.objectIsNotEmpty(this.equipment_offer))) {
                        this.setOfferings(val);
                    }
                    //online
                    if (!!val && (this.quote.payment_method !== this.payment_method.PAYMENT_METHOD_F2F_ONLY && !this.objectIsNotEmpty(this.online_offer))) {
                        this.setOfferings(val);
                    }

                    //
                    if (!!oldVal && !!val){ //never set an old value when quote.package_external_id is empty or undefined.
                        this.old_package_external_id = oldVal
                    }else{
                        this.old_package_external_id = '';
                    }
                }
            },
        }
    }
</script>

<style scoped>
div:np-radios{
  margin-bottom:5px;
}
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        font-weight: lighter;
        font-size: 0.8em;
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 100%;
        height: auto
    }

    .avatar-small {
        width: 100px;
        border-radius: 6px;
        display: block;
        padding: 2px;
        margin: 10px auto;
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .vue-radio-checkbox.np-checkbox.default.form-group {
        min-height: 0 !important;
    }

    .card-header .badge {
        float: right;
    }
</style>
